"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateRef = void 0;
var useConst_1 = require("./useConst");
var evt_1 = require("evt");
var useRerenderOnStateChange_1 = require("evt/hooks/useRerenderOnStateChange");
function useStateRef(initialValue) {
    var evtElement = (0, useConst_1.useConst)(function () { return evt_1.Evt.create(initialValue); });
    (0, useRerenderOnStateChange_1.useRerenderOnStateChange)(evtElement);
    var ref = (0, useConst_1.useConst)(function () {
        var ref = {};
        Object.defineProperty(ref, "current", {
            "get": function () { return evtElement.state; },
            "set": function (current) { return evtElement.state = current; }
        });
        return { ref: ref };
    }).ref;
    return ref;
}
exports.useStateRef = useStateRef;
//# sourceMappingURL=useStateRef.js.map